var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveyRequestActivities({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 18.3327H3.33333C3.11232 18.3327 2.90036 18.2449 2.74408 18.0886C2.5878 17.9323 2.5 17.7204 2.5 17.4993V2.49935C2.5 2.27834 2.5878 2.06637 2.74408 1.91009C2.90036 1.75381 3.11232 1.66602 3.33333 1.66602H16.6667C16.8877 1.66602 17.0996 1.75381 17.2559 1.91009C17.4122 2.06637 17.5 2.27834 17.5 2.49935V17.4993C17.5 17.7204 17.4122 17.9323 17.2559 18.0886C17.0996 18.2449 16.8877 18.3327 16.6667 18.3327ZM6.66667 5.83268V7.49935H13.3333V5.83268H6.66667ZM6.66667 9.16602V10.8327H13.3333V9.16602H6.66667ZM6.66667 12.4993V14.166H10.8333V12.4993H6.66667Z",
    fill: "#9CA2A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyRequestActivities);
export default __webpack_public_path__ + "static/media/survey-request-activities.d0a2c5cd61b4e64c509bb3046ba2507d.svg";
export { ForwardRef as ReactComponent };